import {
  type CSSProperties,
  type MouseEvent,
  useCallback,
  useEffect,
  useMemo,
  useState } from
'react';
import clsx from 'clsx';

import { type Repub, REPUBS } from '@cx-modules/constants';

import { type Bet } from '~/components/BettingInsights/types';
import BettingActions from '~/services/actions/betting-actions';
import { pollForWindowProperty } from '~/utils/pollForWindowObject';

import styles from './styles/BetButton.module.css';
import { OddsButton, type OddsButtonProps } from './cxy';

// TODO: Move everything useful to cxy
export const BetButton = ({
  bet,
  buttonStyles,
  className,
  label,
  onClick,
  repub,
  shouldHideLabelOnDesktop,
  shouldHideLabelOnMobile,
  ...props







}: OddsButtonProps & {bet: Bet;buttonStyles?: CSSProperties;label?: string;repub: Repub;shouldHideLabelOnDesktop?: boolean;shouldHideLabelOnMobile?: boolean;}) => {
  const { bookieName } = props;
  const bettingActions = useMemo(() => new BettingActions(), []);

  const [isBetInBetslip, setIsBetInBetslip] = useState(false);

  useEffect(() => {
    if (repub !== REPUBS.OC.name) return;

    const syncBetslipState = async () => {
      await pollForWindowProperty('ocBetslip');
      const betslip = window.ocBetslip;
      betslip.setCallbacks({
        addBet: ({ betId }) => setIsBetInBetslip(betId === bet.betId),
        removeAllBets: () => setIsBetInBetslip(false),
        removeBet: (betId) => setIsBetInBetslip(betId !== bet.betId)
      });

      setIsBetInBetslip(betslip.isInBetslip(bet.betId));
    };

    syncBetslipState();
  }, [bet.betId, repub]);

  const checkBetslipForBet = useCallback(
    (repub: Repub) => {
      if (repub === REPUBS.OC.name) {
        return window.ocBetslip.isInBetslip(bet.betId);
      }
      const betsInBetslip = bettingActions.getBetslipCookieArray();
      return betsInBetslip.map((item) => item[0]).includes(bet.betId.toString());
    },
    [bet.betId, bettingActions]
  );

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      switch (repub) {
        case REPUBS.OC.name:
          if (window.ocBetslip.isInBetslip(bet.betId)) {
            window.ocBetslip.removeBet({ betId: bet.betId });
          } else {
            window.ocBetslip.addBet(bet);
            window.ocBetslip.toggle();
          }
          break;
        default:
          bettingActions.addOrRemoveFromBetslip(
            [{ betId: bet.betId }],
            [bet.betId],
            bookieName
          );
      }

      onClick?.(e);

      setTimeout(() => {
        setIsBetInBetslip(checkBetslipForBet(repub));
      }, 500);
    },
    [repub, onClick, bet, bettingActions, bookieName, checkBetslipForBet]
  );

  return (
    <>
			<div
        className={clsx(
          styles.betButtonWrapper,
          {
            [styles.shouldHideLabelOnDesktop]: shouldHideLabelOnDesktop,
            [styles.shouldHideLabelOnMobile]: shouldHideLabelOnMobile
          },
          className
        )}
        style={buttonStyles}>

				<p>{label || 'Best Odds'}</p>
				<OddsButton
          aria-pressed={isBetInBetslip}
          data-state={isBetInBetslip ? 'on' : 'off'}
          onClick={handleClick}
          selected={isBetInBetslip}
          {...props}
          className={clsx(styles.betButton, {
            [styles.isSelected]: isBetInBetslip
          })} />

			</div>
		</>);

};